import { useTranslation } from 'react-i18next';
import { cn } from 'lib/utils';
import type { AuditAction } from 'api/adminAuditApi';
import { actionMeta } from 'utils/auditLabels';
import { TONE_CLASSES } from './pillTone';

/** One action's pill — icon + label, never the tone alone (design §3). Shared by the record's
 * timeline (PR8) and the global view's table (PR9). */
const ActionPill = ({ action }: { action: AuditAction }) => {
  const { t } = useTranslation();
  const meta = actionMeta(action);
  const Icon = meta.icon;
  return (
    <span className={cn('inline-flex h-[22px] items-center gap-1.5 rounded-full px-2.5 text-[11.5px] font-medium', TONE_CLASSES[meta.tone])}>
      <Icon className="h-3 w-3" aria-hidden="true" />
      {meta.label(t)}
    </span>
  );
};

export default ActionPill;
